export function safeB64(str: string): string {
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch (e) {
    return btoa(str);
  }
}

export function decodeParam(raw: string | null): string | null {
  if (!raw) return null;
  try {
    const b64 = raw.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(b64);
    if (/^[\x20-\x7E\u00C0-\u024F\u0400-\u04FF]+$/.test(decoded)) {
      return decoded.trim();
    }
  } catch (e) {  }
  return raw.trim();
}

export function getRawName(): string | null {
  const std = new URLSearchParams(window.location.search).get('p');
  if (std) return std;
  const raw = window.location.search;
  const m = raw.match(/[?&]p=([^&]+)/);
  if (m) return decodeURIComponent(m[1]);
  return null;
}

export function getDecodedName(): string {
  return decodeParam(getRawName()) || 'Martins';
}

export function initials(name: string): string {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function isValidEmail(e: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim());
}

export function getEmailFromPath(): string | null {
  try {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    
    // First try to get email from path segments (e.g., /meet/email)
    if (pathSegments.length >= 2) {
      // Email is the second segment (after 'meet')
      // Handle both /meet/email and /meet/email/ (with trailing slash)
      let pathEmail = pathSegments[1];
      if (pathEmail && pathEmail !== 'nm') {
        // If there's a third segment and it's empty (trailing slash), that's OK
        // The email is still in pathSegments[1]
        
        try {
          const decoded = atob(pathEmail.replace(/-/g, '+').replace(/_/g, '/'));
          if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(decoded)) {
            return decoded;
          }
        } catch (e) {}
        
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pathEmail)) {
          return pathEmail;
        }
      }
    }
    
    // Fallback: check query string for email format (e.g., /meet/?email?p=name)
    const query = window.location.search.substring(1);
    if (query) {
      // Split by ? to separate email from p= parameter
      // Format: Y2hyaXN0aW5hLmJhc3RsQGluY3Jlb24uY29t?p=Y2hyaXN0aW5h
      const queryParts = query.split('?');
      const firstPart = queryParts[0];
      
      if (firstPart) {
        try {
          // Try to decode as base64
          const decoded = atob(firstPart.replace(/-/g, '+').replace(/_/g, '/'));
          if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(decoded)) {
            return decoded;
          }
        } catch (e) {}
        
        // Try as plain email
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(firstPart)) {
          return firstPart;
        }
      }
    }
    
    return null;
  } catch (e) { return null; }
}

export function getEmailFromURL(): string | null {
  try {
    const query = window.location.search.substring(1);
    if (!query) {
      console.log('No query string found');
      return null;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    try {
      const b64 = query.replace(/-/g, '+').replace(/_/g, '/');
      const decoded = atob(b64);
      
      if (emailRegex.test(decoded)) {
        console.log('Decoded email (base64):', decoded);
        return decoded;
      }
    } catch (e) {
      console.log('Base64 decoding failed, trying plain text format');
    }
    
    if (emailRegex.test(query)) {
      console.log('Using plain text email:', query);
      return query;
    }
    
    console.log('Invalid email format:', query);
    return null;
  } catch (e) {
    console.error('Error extracting email from URL:', e);
    return null;
  }
}

export function getCountryFromBrowser(): string {
  try {
    const lang = navigator.language || (navigator as unknown as { userLanguage?: string }).userLanguage;
    if (lang && lang.includes('-')) {
      return lang.split('-')[1].toUpperCase();
    }
    return 'US';
  } catch (e) {
    return 'US';
  }
}
